import type { EventRegistrationMode } from "../api/events";

/** Events that use conference registration before the API returns registrationMode. */
const CONFERENCE_EVENT_SLUGS = new Set([
  "ieee-dtpi-2026",
  "ieee-isi-2026",
  "2026-idass",
  "2026-icast",
]);

export function resolveRegistrationMode(
  slug: string,
  mode?: EventRegistrationMode | null,
): EventRegistrationMode {
  if (mode === "conference" || mode === "tickets" || mode === "invitation") {
    return mode;
  }
  if (CONFERENCE_EVENT_SLUGS.has(slug)) return "conference";
  return "tickets";
}
